<template>
  <printed-form-card v-if="debtorChronology">
    <div>
      <div class="font-weight-bold mb-3">{{ label }}</div>

      <v-chip
        v-if="debtorChronology.status === 'completed'"
        style="width: fit-content"
        density="compact"
        color="success"
        variant="tonal">
        <v-icon icon="mdi-check-circle-outline" class="mr-2"></v-icon>
        <span>
          Сформовано
          {{
            new CustomDate(debtorChronology.created_at).toString({
              time: true,
            })
          }}
        </span>
      </v-chip>
      <v-chip
        v-if="debtorChronology.status === 'inProgress'"
        style="width: fit-content"
        density="compact"
        color="warning"
        variant="tonal">
        <v-icon icon="mdi-progress-clock" class="mr-2"></v-icon>
        <span>У процесі формування</span>
      </v-chip>
      <v-chip
        v-if="debtorChronology.status === 'error'"
        style="width: fit-content"
        density="compact"
        color="error"
        variant="tonal">
        <v-icon icon="mdi-alert-circle-outline" class="mr-2"></v-icon>
        <span>Помилка</span>
      </v-chip>
    </div>

    <v-btn
      density="comfortable"
      :disabled="debtorChronology.status !== 'completed'"
      @click="viewReport()">
      Переглянути звіт
    </v-btn>
  </printed-form-card>
</template>

<script lang="ts">
import PrintedFormCard from '../components/PrintedFormCard.vue'
import { PropType } from 'vue'
import { DebtorChronology } from '@/utils/types'
import { CustomDate } from 'best-modules/utils'
import { openDialog } from '@/plugins/dialog'

export default {
  name: 'DebtorChronologyResultItem',
  components: { PrintedFormCard },
  props: {
    debtorChronology: {
      type: Object as PropType<DebtorChronology | null>,
    },
    label: {
      type: String,
    },
  },
  methods: { CustomDate },
  setup(props) {
    const viewReport = () => {
      if (props.debtorChronology) {
        openDialog({
          name: 'DebtorChronologyView',
          dialogData: { debtorChronology: props.debtorChronology },
        })
      }
    }

    return { viewReport }
  },
}
</script>

<style scoped lang="scss"></style>
